import { useState } from 'react';
import { motion } from 'motion/react';
import { Lock } from 'lucide-react';
import { useNavigate } from 'react-router';
import { API_BASE } from '../utils/siteConfig';
import { setAdminCsrf } from '../utils/api';

export function AdminLogin() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    try {
      const response = await fetch(`${API_BASE}/auth.php?action=login`, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email: username, password }) });
      const data = await response.json();
      if (!response.ok || !data.success) { setError(data.error || 'Unable to sign in.'); return; }
      setAdminCsrf(data.csrf); navigate('/admin/dashboard');
    } catch { setError('Unable to sign in. Please try again.'); }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6">
      <motion.div
        className="max-w-md w-full bg-white p-8 rounded-3xl shadow-xl border border-slate-100"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <div className="w-16 h-16 bg-indigo-50 rounded-2xl flex items-center justify-center text-indigo-600 mb-6 mx-auto">
          <Lock size={32} />
        </div>
        <h2 className="text-3xl font-bold text-center text-slate-900 mb-8">Secure Admin Login</h2>
        
        <form onSubmit={handleLogin} className="flex flex-col gap-4">
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-2">Email</label>
            <input
              type="email"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all"
              placeholder="admin@example.com"
              autoComplete="username"
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-2">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all"
              placeholder="Your password"
              autoComplete="current-password"
              required
            />
          </div>
          
          {error && <p className="text-red-500 text-sm text-center">{error}</p>}
          
          <button
            type="submit"
            className="w-full py-4 mt-4 bg-gradient-to-r from-indigo-600 to-cyan-500 text-white rounded-xl font-medium shadow-lg shadow-indigo-200 hover:shadow-xl transition-all"
          >
            Login to Dashboard
          </button>
        </form>
      </motion.div>
    </div>
  );
}
